module.exports = __webpack_public_path__ + "img/payconiq.cabb6168.svg";